import { useMemo } from 'react';
import { mergeAlertEvents, useAlertsStore } from '@/stores';
import type { AlertRuleEvent } from '@/types/event';

export function useMergedAlertFeedEvents(
    events: AlertRuleEvent[],
    itemKey: (alert: AlertRuleEvent) => string,
    filter?: (alert: AlertRuleEvent) => boolean,
): AlertRuleEvent[] {
    const recentAlerts = useAlertsStore((state) => state.recentAlerts);

    return useMemo(() => {
        const liveAlerts = filter ? recentAlerts.filter(filter) : recentAlerts;
        return mergeAlertEvents(liveAlerts, events, itemKey);
    }, [recentAlerts, events, itemKey, filter]);
}
